import { Store } from './type'

export const selectEnvironment = (store: Store): Store['environment'] =>
  store.environment

export const selectEnvironmentSetter = (
  store: Store,
): Store['setEnvironment'] => store.setEnvironment

export const selectActiveBanner = (store: Store): Store['activeBanner'] =>
  store.activeBanner

export const selectSetBanner = (store: Store): Store['setBanner'] =>
  store.setBanner

// email selector
export const selectEmail = (store: Store): Store['email'] => store.email
export const selectSetEmail = (store: Store): Store['setEmail'] =>
  store.setEmail

export const selectRemoveBanner = (store: Store): Store['removeBanner'] =>
  store.removeBanner

export const selectResendActivationEmail = (
  store: Store,
): Store['resendActivationEmail'] => store.resendActivationEmail

export const selectBrand = (store: Store): Store['brand'] => store.brand
export const selectLang = (store: Store): Store['lang'] => store.lang

export const selectCurrentPath = (store: Store): Store['currentPath'] =>
  store.currentPath
export const selectPreviousPath = (store: Store): Store['previousPath'] =>
  store.previousPath
export const selectSetCurrentPath = (store: Store): Store['setCurrentPath'] =>
  store.setCurrentPath
